module.exports = __webpack_public_path__ + "media/images/emblems/Stein-blason-9261f1509119069515c7a12cb7933d26.png";